import type { PropsWithChildren } from 'react';
import { memo, useRef } from 'react';
import type { ReactNodeLike } from 'prop-types';
import { OptimizelyProvider } from '@optimizely/react-sdk';

import OptimizelyNotifications from 'Components/OptimizelyNotifications/OptimizelyNotifications';
import type { ConfigDatafile } from 'Services/optimizely/optimizely';
import { getUserAttributesPayload, optimizelyInstanceFactory } from 'Services/optimizely/optimizely';
import type { User } from 'Types/user';

interface OptimizelyInitialiserProps {
	children: NonNullable<ReactNodeLike>;
	optimizelyDatafile: ConfigDatafile;
	user?: User;
}

export const OptimizelyInitialiserComponent: React.FC<PropsWithChildren<OptimizelyInitialiserProps>> = ({
	children,
	optimizelyDatafile,
	user,
}) => {
	const datafileRef = useRef(optimizelyDatafile ?? null);

	if (!user) {
		return <>{children}</>;
	}

	const optimizelyInstance = optimizelyInstanceFactory(datafileRef.current);
	const optimizelyUser = {
		attributes: {
			...getUserAttributesPayload({
				dealerContactId: user?.id,
				dealershipId: user?.dealerId,
			}),
		},
		id: user ? String(user.id) : null,
	};

	return (
		<OptimizelyProvider optimizely={optimizelyInstance} user={optimizelyUser}>
			<OptimizelyNotifications />
			{children}
		</OptimizelyProvider>
	);
};

export const OptimizelyInitialiser = memo(OptimizelyInitialiserComponent);
